export const currencyFormat = (price) => {
  return price
    ? parseFloat(price)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
    : "0.00";
};
